import React, { useState, useEffect } from "react";
import FormField from "../../../components/ui/FormField";
import { Button } from "../../../components/Button";

const RegisterDirAndKmpForm = () => {
    const [registers, setRegisters] = useState(() => {
        const saved = localStorage.getItem("kmp_register_data");
        return saved ? JSON.parse(saved) : [{
            id: Date.now(),
            details: {},
            securities: [{ id: Date.now() }]
        }];
    });

    
    useEffect(() => {
        localStorage.setItem("kmp_register_data", JSON.stringify(registers));
    }, [registers]);

    const updateField = (id, section, field, value) => {
        setRegisters(prev => prev.map(reg => 
            reg.id === id ? { ...reg, [section]: { ...reg[section], [field]: value } } : reg
        ));
    };
const handleSave = () => {
    const jsonData = {
        generatedAt: new Date().toISOString(),
        totalDirectorsOrKMP: registers.length,
        registerData: registers
    };

    console.log(
        "Director / KMP Register JSON:\n",
        JSON.stringify(jsonData, null, 2)
    );

    alert("Data saved! Open console to view formatted JSON.");
};


    const addSecurityEntry = (id) => {
        setRegisters(prev => prev.map(reg => 
            reg.id === id ? { ...reg, securities: [...reg.securities, { id: Date.now() }] } : reg
        ));
    };

    const updateSecurityField = (regId, secId, field, value) => {
        setRegisters(prev => prev.map(reg => {
            if (reg.id !== regId) return reg;
            return {
                ...reg,
                securities: reg.securities.map(sec => 
                    sec.id === secId ? { ...sec, [field]: value } : sec
                )
            };
        }));
    };

    const addDirector = () => {
        setRegisters([...registers, { id: Date.now(), details: {}, securities: [{ id: Date.now() }] }]);
    };

    return (
        <div>
            <div className="bg-white border border-gray-300 p-8 rounded shadow-sm mb-6">
                <h1 className="text-center text-xl font-bold uppercase mb-1">Register of Directors and Key Managerial Personnel and their Shareholding</h1>
                <p className="text-center text-[10px] italic mb-6">[Pursuant to section 88 (1)(a) of the Companies Act, 2013 and rule 3(1) of the Companies (Management and Administration) Rules, 2014]</p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 border-b pb-6 mb-6">
                    <FormField label="Name of the company" />
                    <FormField label="Registered office address" type="description" />
                    <div className="col-span-full font-bold text-xs italic text-gray-500">(TO BE MAINTAINED SEPARATELY FOR EACH DIRECTOR AND KMP)</div>
                </div>

                {registers.map((reg, index) => (
                    <div key={reg.id} className="border-2 border-gray-200 rounded-lg p-6 mb-10 relative bg-white">
                        <div className="absolute -top-3 left-4 bg-primary text-white px-3 py-1 text-[10px] font-bold rounded">
                            DIRECTOR / KMP RECORD #{index + 1}
                        </div>
                        
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-4">
                            <div className="space-y-3">
                                <FormField label="Director Identification Number (optional for key managerial personnel)" value={reg.details.din} onChange={(v) => updateField(reg.id, 'details', 'din', v)} />
                                <FormField label="Present name and surname in full" value={reg.details.presentName} onChange={(v) => updateField(reg.id, 'details', 'presentName', v)} />
                                <FormField label="Any former name or surname in full" value={reg.details.formerName} onChange={(v) => updateField(reg.id, 'details', 'formerName', v)} />
                                <FormField label="Father's Name" value={reg.details.fatherName} onChange={(v) => updateField(reg.id, 'details', 'fatherName', v)} />
                                <FormField label="Mother's Name" value={reg.details.motherName} onChange={(v) => updateField(reg.id, 'details', 'motherName', v)} />
                                <FormField label="Spouse's Name (If married)" value={reg.details.spouseName} onChange={(v) => updateField(reg.id, 'details', 'spouseName', v)} />
                                <FormField label="Date of birth" type="date" value={reg.details.dob} onChange={(v) => updateField(reg.id, 'details', 'dob', v)} />
                            </div>

                            <div className="space-y-3">
                                <FormField label="Nationality (including the nationality of origin, if different)" value={reg.details.nationality} onChange={(v) => updateField(reg.id, 'details', 'nationality', v)} />
                                <FormField label="Occupation" value={reg.details.occupation} onChange={(v) => updateField(reg.id, 'details', 'occupation', v)} />
                                <FormField label="Date of the board resolution in which the appointment was made" type="date" value={reg.details.resDate} onChange={(v) => updateField(reg.id, 'details', 'resDate', v)} />
                                <FormField label="Date of appointment and reappointment in the company" type="date" value={reg.details.appointDate} onChange={(v) => updateField(reg.id, 'details', 'appointDate', v)} />
                                <FormField label="Date of cessation of office and reasons therefor" type="date" value={reg.details.cessationDate} onChange={(v) => updateField(reg.id, 'details', 'cessationDate', v)} />
                                <FormField label="Office of director or KMP held or relinquished in any other body corporate" type="description" value={reg.details.otherOffice} onChange={(v) => updateField(reg.id, 'details', 'otherOffice', v)} />
                                <FormField label="Membership number of the ICSI in case of Company Secretary, if applicable" value={reg.details.icsiNo} onChange={(v) => updateField(reg.id, 'details', 'icsiNo', v)} />
                                <FormField label="Permanent Account Number (mandatory for KMP if not having DIN)" type="pancard" value={reg.details.pan} onChange={(v) => updateField(reg.id, 'details', 'pan', v)} />
                            </div>
                        </div>

                        <div className="mt-8 border-t pt-6">
                            <h3 className="font-bold text-sm uppercase mb-4 underline">Residential address:</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                <FormField label="Present Address" type="description" value={reg.details.presentAddr} onChange={(v) => updateField(reg.id, 'details', 'presentAddr', v)} />
                                <FormField label="Permanent Address" type="description" value={reg.details.permAddr} onChange={(v) => updateField(reg.id, 'details', 'permAddr', v)} />
                            </div>
                        </div>

                        {/* Details of Securities Section (Replaces Table) */}
                        <div className="mt-8 border-t pt-6">
                            <div className="flex justify-between items-center mb-4">
                                <h3 className="font-bold text-sm uppercase underline">Details of securities held in the Company, its holding company, subsidiaries...</h3>
                                <button onClick={() => addSecurityEntry(reg.id)} className="text-[10px] bg-primary text-white px-2 py-1 rounded">+ Add Security Entry</button>
                            </div>

                            {reg.securities.map((sec, sIdx) => (
                                <div key={sec.id} className="p-4 bg-gray-50 border rounded-md mb-4 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
                                    <div className="col-span-full font-bold text-[10px] text-gray-400">Security Entry #{sIdx + 1}</div>
                                    <FormField label="(1) S. No." value={sec.sno} onChange={(v) => updateSecurityField(reg.id, sec.id, 'sno', v)} />
                                    <FormField label="(2) Name of the Company" value={sec.compName} onChange={(v) => updateSecurityField(reg.id, sec.id, 'compName', v)} />
                                    <FormField label="(4) Number of Securities" type="number" value={sec.numSec} onChange={(v) => updateSecurityField(reg.id, sec.id, 'numSec', v)} />
                                    <FormField label="(5) Description of Securities" value={sec.descSec} onChange={(v) => updateSecurityField(reg.id, sec.id, 'descSec', v)} />
                                    <FormField label="(6) Nominal Value" value={sec.nomVal} onChange={(v) => updateSecurityField(reg.id, sec.id, 'nomVal', v)} />
                                    <FormField label="(7) Date of Acquisition" type="date" value={sec.acqDate} onChange={(v) => updateSecurityField(reg.id, sec.id, 'acqDate', v)} />
                                    <FormField label="(8) Price paid for acquisition" value={sec.acqPrice} onChange={(v) => updateSecurityField(reg.id, sec.id, 'acqPrice', v)} />
                                    <FormField label="(9) Other consideration for acquisition" value={sec.acqOther} onChange={(v) => updateSecurityField(reg.id, sec.id, 'acqOther', v)} />
                                    <FormField label="(10) Date of disposal" type="date" value={sec.dispDate} onChange={(v) => updateSecurityField(reg.id, sec.id, 'dispDate', v)} />
                                    <FormField label="(11) Price received on disposal" value={sec.dispPrice} onChange={(v) => updateSecurityField(reg.id, sec.id, 'dispPrice', v)} />
                                    <FormField label="(13) Cumulative balance held" value={sec.cumBal} onChange={(v) => updateSecurityField(reg.id, sec.id, 'cumBal', v)} />
                                    <FormField label="(14) Mode of acquisition" value={sec.modeAcq} onChange={(v) => updateSecurityField(reg.id, sec.id, 'modeAcq', v)} />
                                    <FormField label="(15) Mode: Physical / Demat" value={sec.modeHold} onChange={(v) => updateSecurityField(reg.id, sec.id, 'modeHold', v)} />
                                    <FormField label="(16) Pledged/Encumbrance Details" type="description" value={sec.pledge} onChange={(v) => updateSecurityField(reg.id, sec.id, 'pledge', v)} />
                                </div>
                            ))}
                        </div>
                        
                        <button onClick={() => setRegisters(registers.filter(r => r.id !== reg.id))} className="mt-4 text-xs text-red-500 hover:underline">Remove this Director Record</button>
                    </div>
                ))}

                <Button label='Add Another Director / KMP' onClick={addDirector} className="mt-2 mr-2" />
                   
                <Button 
                label="Save Register Data"
    onClick={handleSave}
    className="mt-2 ml-2"
/>

            </div>
        </div>
    );
};

export default RegisterDirAndKmpForm;